import { Controller } from "react-hook-form";

import AssigneeFilter from "components/form_components/AssigneeFilter";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

function CreatedByFilterContent({ control }: LeadFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Created by filter">
      <Controller
        name="createdBy"
        control={control}
        render={({ field }) => <AssigneeFilter {...field} />}
      />
    </StyledFilterContent>
  );
}

export default CreatedByFilterContent;
